<template>
  <div>
    <commonRecord :recordType="1"></commonRecord>
  </div>
</template>

<script>
  import commonRecord from '@/views/IM/model/commonRecord.vue'

  export default {
    name: 'artificialRecord',
    components: { commonRecord }
  }
</script>
